/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssignedStructureTeam
 */
export interface AssignedStructureTeam {
    /**
     * 
     * @type {string}
     * @memberof AssignedStructureTeam
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof AssignedStructureTeam
     */
    name?: string;
}

/**
 * Check if a given object implements the AssignedStructureTeam interface.
 */
export function instanceOfAssignedStructureTeam(value: object): value is AssignedStructureTeam {
    return true;
}

export function AssignedStructureTeamFromJSON(json: any): AssignedStructureTeam {
    return AssignedStructureTeamFromJSONTyped(json, false);
}

export function AssignedStructureTeamFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssignedStructureTeam {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function AssignedStructureTeamToJSON(json: any): AssignedStructureTeam {
    return AssignedStructureTeamToJSONTyped(json, false);
}

export function AssignedStructureTeamToJSONTyped(value?: AssignedStructureTeam | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

